import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=c591781a&scoped=true"
import script from "./MessageListItem.vue?vue&type=script&lang=ts"
export * from "./MessageListItem.vue?vue&type=script&lang=ts"
import style0 from "./MessageListItem.vue?vue&type=style&index=0&id=c591781a&prod&scoped=true&lang=scss"
import style1 from "./MessageListItem.vue?vue&type=style&index=1&id=c591781a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c591781a",
  null
  
)

export default component.exports